import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { FacetPicker } from '../components/FacetPicker.js';
import { FacetWithImage } from '../components/FacetWithImage.js';

const FacetPickerOther = ({ onPick , activeFacet , items , className , enableStockIndicator , productType ,  })=>{
    const { getFormattedLabel  } = useIntl();
    if (items.length === 0) {
        return null;
    }
    const title = getFormattedLabel('products.numberOfVariants', {
        labelData: {
            number: items.length
        }
    });
    return /*#__PURE__*/ React.createElement(FacetPicker, {
        itemComponent: FacetWithImage,
        productType: productType,
        title: title,
        items: items,
        onPick: onPick,
        activeFacet: activeFacet,
        showFacetName: activeFacet === null || activeFacet === void 0 ? void 0 : activeFacet.showFacetName,
        className: className,
        enableStockIndicator: enableStockIndicator
    });
};

export { FacetPickerOther };
//# sourceMappingURL=FacetPickerOther.js.map
